export interface IAccessRequest {
  personnel_id: string;
  due_date: string;
  request_priority: string;
  request_category: string;
  system: string;
  message: string;
  request_to: string;
  role: string;
  site_id: string;
  study_id: string;
  request_id: number;
  is_active: boolean;
  created_by: string;
  created_on: string;
  display_request_id: string;
}

export enum AccessRequestMode {
  None,
  Edit,
  View
}

export interface IAccessRequestState {
  accessRequest: Partial<IAccessRequest>;
  open: boolean;
  mode: AccessRequestMode;
}

export interface IAccessRequestPost {
  personnel_id: string;
  due_date: string;
  request_priority: string;
  request_category: string;
  system: string;
  message: string;
  request_to: string;
  role: string;
  created_by: string;
}

export interface IAccessRequestUpdate {
  site_id: string;
  study_id: string;
  data: IAccessRequestPost;
}

export interface IAccessRequestlFieldUpdate {
  key: keyof IAccessRequest;
  value: any;
}
